<template>
  <div class="total-sum">{{ total / 100 }} €</div>
</template>

<script>
export default {
  name: 'Totals',
  data: function() {
    return {
      grandTotal: 0
    }
  },
  computed: {
    total() {
      return this.$store.getters['basket/basketTotal']
    }
  },
  methods: {
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(',', '.')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '')
    }
  }
}
</script>
